import React, { useState } from 'react';
import { Grid, Tab, Tabs, Box, useMediaQuery } from '@mui/material';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import WineBarIcon from '@mui/icons-material/WineBar';
import HikingRoundedIcon from '@mui/icons-material/HikingRounded';

import Guests from './guests/Guests';
import RoomTypeRatePlan from './roomType/RoomTypeRatePlan';
import Summary from './summary/Summary';
import Products from '../pages/Products';
import Activities from '../pages/Activities';
import Banner from './banner/Banner';
import Calendar2 from './calendar/Calendar2';
import PromotionalCode from './promotionalCode/PromotionalCode';

const MainComponent = () => {
    const [value, setValue] = useState(0);
    const navigate = useNavigate();
    const location = useLocation(); // Hook para obtener la ruta actual
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    const handleChange = (event, newValue) => {
        setValue(newValue);
        switch (newValue) {
            case 0:
                navigate('/MotorReservasAdmintour/disponibilidad/habitaciones');
                break;
            case 1:
                navigate('/MotorReservasAdmintour/disponibilidad/productos');
                break;
            case 2:
                navigate('/MotorReservasAdmintour/disponibilidad/actividades');
                break;
            default:
                navigate('/MotorReservasAdmintour/disponibilidad/habitaciones');
        }
    };

    return (
        <Box sx={{ mt: 0, px: isMobile ? 2 : 0 }}>
            <Box sx={{ position: 'relative', zIndex: 1, mt: 0 }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="Disponibilidad Tabs"
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        width: '100%',
                        justifyContent: 'flex-start',
                        borderBottom: 'none',
                    }}
                >
                    <Tab label="Habitaciones" icon={<BedOutlinedIcon />} iconPosition="start" />
                    {/*<Tab label="Productos" icon={<WineBarIcon />} iconPosition="start" />
                    <Tab label="Actividades" icon={<HikingRoundedIcon />} iconPosition="start" />*/}
                </Tabs>
            </Box>
            <Box sx={{ width: '100vw', position: 'relative', left: '50%', right: '50%', marginLeft: '-50vw', marginRight: '-50vw', overflowX: 'hidden', mt: 2 }}>
                <Banner />
            </Box>
            {location.pathname.startsWith('/MotorReservasAdmintour/disponibilidad/habitaciones') && (
                <Box sx={{ 
                    position: 'relative', 
                    zIndex: 2, 
                    width: '80%', 
                    maxWidth: '900px',
                    mx: 'auto',
                    mt: '-50px', 
                    backgroundColor: 'white', 
                    borderRadius: '12px', 
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)', 
                    padding: '20px',
                }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={5}>
                            <Calendar2 />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Guests />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <PromotionalCode />
                        </Grid>
                    </Grid>
                </Box>
            )}

            <Grid container spacing={2} mt={6} sx={{ px: isMobile ? 2 : 0 }}>
                <Routes>
                    <Route path="/" element={<Navigate to="/MotorReservasAdmintour/disponibilidad/habitaciones" replace />} />
                    <Route path="/habitaciones" element={
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <RoomTypeRatePlan />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Summary />
                            </Grid>
                        </Grid>
                    } />
                    {/*<Route path="/productos" element={
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Products />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Summary />
                            </Grid>
                        </Grid>
                    } />
                    <Route path="/actividades" element={
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={8}>
                                <Activities />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Summary />
                            </Grid>
                        </Grid>
                    } />*/}
                </Routes>
            </Grid>
        </Box>
    );
};

export default MainComponent;